@if (isAppReady() && !authService.isLoggingOut()) {
  <router-outlet></router-outlet>
} @else {
  <app-loader mode="fullscreen" size="lg" />
}

<!-- Hors du @if : une erreur au démarrage doit rester visible pendant le chargement -->
<ngx-sonner-toaster
  position="top-right"
  [closeButton]="true"
  [visibleToasts]="4"
  [toastOptions]="toastOptions"
/>

<!-- Modal de sélection de pays -->
@if (showCountrySelector()) {
  <app-country-selector-modal (closeModal)="onCountrySelected()" />
}
